import { render, staticRenderFns } from "./Found.vue?vue&type=template&id=b72f7410&scoped=true&"
import script from "./Found.vue?vue&type=script&lang=js&"
export * from "./Found.vue?vue&type=script&lang=js&"
import style0 from "./Found.vue?vue&type=style&index=0&id=b72f7410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f7410",
  null
  
)

export default component.exports